import React from 'react'
import logoFavicon from '../../../assets/Favicon.png'
import { Link } from 'react-router-dom'

const NavResponsiv = () => {
    return (
        <div className="d-block d-sm-none fixed-bottom container bg-secondary text-white" style={{height: '60px'}}>
            
            <div className="row justify-content-center text-center">

                <div className="col-2 m-1 ">
                    <Link to="/index.html" className="text-decoration-none text-white">
                        <img src={logoFavicon} className="img-fluid" style={{height: 18+"px", width: 18+"px"}} alt="logo favicon"/>
                        <p>home</p>
                    {/* <div className="image" style={{backgroundImage: `url(${logoBottinMondain})`, height: 520+'px', width: 100+'%',  backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}/> */}
                    </Link>
                </div>

                <div className="col-2 m-1">
                    <Link to="/artistes" className="text-decoration-none text-white">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-person-lines-fill" viewBox="0 0 16 16">
                            <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z"/>
                        </svg>
                        <p className="" style={{marginLeft: "-7px"}}>artiste</p>
                    </Link>
                </div>

                <div className="col-2 m-1">
                    <Link to="/GalerieVirtuelle" className="text-decoration-none text-white">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-display" viewBox="0 0 16 16">
                            <path d="M0 4s0-2 2-2h12s2 0 2 2v6s0 2-2 2h-4c0 .667.083 1.167.25 1.5H11a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1h.75c.167-.333.25-.833.25-1.5H2s-2 0-2-2V4zm1.398-.855a.758.758 0 0 0-.254.302A1.46 1.46 0 0 0 1 4.01V10c0 .325.078.502.145.602.07.105.17.188.302.254a1.464 1.464 0 0 0 .538.143L2.01 11H14c.325 0 .502-.078.602-.145a.758.758 0 0 0 .254-.302 1.464 1.464 0 0 0 .143-.538L15 9.99V4c0-.325-.078-.502-.145-.602a.757.757 0 0 0-.302-.254A1.46 1.46 0 0 0 13.99 3H2c-.325 0-.502.078-.602.145z"/>
                        </svg>
                        <p style={{marginLeft: "-9px"}}>galleries</p>
                    </Link>
                </div>

                <div className="col-2 m-1">
                    <Link to="/agenda" className="text-decoration-none text-white">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-calendar-day-fill" viewBox="0 0 16 16">
                            <path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5h16v9zm-4.785-6.145a.428.428 0 1 0 0-.855.426.426 0 0 0-.43.43c0 .238.192.425.43.425zm.336.563h-.672v4.105h.672V8.418zm-6.867 4.105v-2.3h2.261v-.61H4.684V7.801h2.464v-.61H4v5.332h.684zm3.296 0h.676V9.98c0-.554.227-1.007.953-1.007.125 0 .258.004.329.015v-.613a1.806 1.806 0 0 0-.254-.02c-.582 0-.891.32-1.012.567h-.02v-.504H7.98v4.105z"/>
                        </svg>
                        <p style={{marginLeft: "-9px"}}>agenda</p>
                    </Link>
                </div>

                <div className="col-2 m-1">
                    <Link to="/Videos" className="text-decoration-none text-white">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-play-btn" viewBox="0 0 16 16">
                            <path d="M6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z"/>
                            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"/>
                        </svg>
                        <p style={{marginLeft: "-9px"}}>videos</p>
                    </Link>
                </div>

            </div>
                
            
        </div>
    )
}

export default NavResponsiv
